import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FormikSelect } from '../../components';
import SettingsCard from '../../components/Utils/Cards/SettingsCard';

export const renderGrid = (names, cols, listedSettings, cardBody) => (
  <Row>
    {names.map(name => {
      const body = listedSettings.find(s => s.name === name);
      if (!body) return null;
      return (
        <Col key={name} md={12 / cols}>
          <SettingsCard
            size="100%"
            colorCard="white"
            classNameCard="z-index-auto"
            divBody
            bodyMarginBottom="-10px"
            text={cardBody(body)}
          />
        </Col>
      );
    })}
  </Row>
);

export const remCardBody = (
  { text, name, inputType },
  settingData,
  canUpdateSettings,
  conditionsEnum,
  changeSettingSelector,
  settingUpdate
) => {
  const isToggle = inputType === 'toggle';
  let settIndex = '';
  if (settingData.length) {
    settIndex = settingData.findIndex(v => v.code === name);
    if (settIndex < 0) settIndex = '';
  }

  return (
    <Row>
      <Col sm={isToggle ? 9 : 8} md={12} lg={isToggle ? 6 : 5} xl={isToggle ? 8 : 6}>
        <p className="text-uppercase mt-1" style={{ letterSpacing: '1.5px' }}>
          {text}
        </p>
      </Col>
      <Col
        xs={6}
        sm={isToggle ? 2 : 3}
        md={6}
        lg={isToggle ? 4 : 5}
        xl={isToggle ? 3 : 6}
        className={`${isToggle ? 'd-flex justify-content-lg-end' : ''}`}
      >
        {inputType === 'selector' && (
          <FormikSelect
            label=""
            options={conditionsEnum}
            isDisabled={!canUpdateSettings}
            value={settingData[settIndex]?.textValue}
            defaultValue={settingData[settIndex]?.textValue}
            placeholder="Seleccionar"
            onChange={opt => {
              changeSettingSelector(settIndex, opt.value);
              settingUpdate(settingData[settIndex]);
            }}
          />
        )}
      </Col>
    </Row>
  );
};

export const renderRemGrid = (items, cols, remCardBodyFn) => (
  <Row>
    {items.map(body => (
      <Col key={`rem-${body.name}`} md={12 / cols}>
        <SettingsCard
          size="100%"
          colorCard="white"
          classNameCard="z-index-auto"
          divBody
          bodyMarginBottom="-10px"
          text={remCardBodyFn(body)}
        />
      </Col>
    ))}
  </Row>
);
